"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../utils/index");
var createSEOLite = function createSEOLite(_ref) {
  var fields = _ref.fields;
  return {
    changeFrequency: (0, _index.getProp)(fields, 'changeFrequency') || 'weekly',
    priority: (0, _index.getProp)(fields, 'sitemapPriority') || 0.5,
    noIndex: (0, _index.getProp)(fields, 'noIndex'),
    noFollow: (0, _index.getProp)(fields, 'noFollow')
  };
};
var _default = createSEOLite;
exports["default"] = _default;